<template>
    <div>
        <div class="modal fade bd-example-modal-lg termsModal" ref="rejectModal" id="reject-modal" tabindex="-1"
             role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <form>
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="rejectUserModal">Explain why the user is rejected</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <textarea class="form-control" height="400px" placeholder="Comment for rejecting user"
                                      v-model="form.comment"></textarea>
                            <span class="help is-danger" v-if="form.errors.has('comment')"
                                  v-text="form.errors.get('comment')"></span>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-dark" data-dismiss="modal">Go back
                            </button>
                            <button type="button" @click="confirmReject" class="btn btn-danger" data-dismiss="modal" :disabled="locked">Reject
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <a :href="acceptRoute">Accept</a>
        <a :href="rejectRoute" @click.prevent="reject">Reject</a>
    </div>
</template>

<script>
  import TForm from './TForm';

  export default {
    name: 'ValidateUser',
    props: {
      acceptRoute: {
        type: String,
        required: true,
      },
      rejectRoute: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        locked: false,
        form: new TForm({
          comment: '',
        }),
      };
    },
    methods: {
      lock() {
        this.locked = true;
      },
      unlock() {
        this.locked = false;
      },
      reject() {
        $(this.$refs.rejectModal).modal('show');
      },
      confirmReject() {
        if (this.locked) {
          return;
        }
        this.lock();
        this.form.post(this.rejectRoute).then(data => {
          location.reload();
        }).catch(error => {
          this.$toasted.error(error.message);
          this.unlock();
        });
      },
    },
  };
</script>

<style scoped>

</style>
